/**
 * Расчет колва слайдов при адаптации
 * @param {Number} [slideWidth] - ширина слайда
 * @param {Number} [maxSlideCount] - максимальное число слайдов для отображения
 * @param {String} [sliderType = 'siema'] - тип сладера. Доступные варианты: 'siema', 'slick'
 * @returns {Array | Object}
 */
export default function getResponsiveParams (slideWidth, maxSlideCount, sliderType = 'siema') {
	if (sliderType === 'siema') {
		let oResponsiveParams = {};
		for (let i = 1; i <= maxSlideCount; i++) {
			oResponsiveParams[slideWidth * i] = i;
		}
		return oResponsiveParams;
	} else if (sliderType === 'slick') {
		let arrResponsiveParams = [];
		for (let i = 1; i <= maxSlideCount; i++) {
			arrResponsiveParams.push({
				breakpoint: slideWidth * i,
				settings: {
					slidesToShow: i
				}
			});
		}
		return arrResponsiveParams;
	}
}



// WEBPACK FOOTER //
// ./_HTML/src/js/_utils/getResponsiveParams.js